angular.module('gym.mobile_app').directive('mobileAppSettingsAccessSettings', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/mobile_app/access_settings.html.slim'),
    controller: ["$scope", "$rootScope", "MobileApp", "MobileAppService", "MessageService", "flash", "$window", function($scope, $rootScope, MobileApp, MobileAppService, MessageService, flash, $window) {
      var saveSettings;
      $scope.gym = $rootScope.gym;
      MobileApp.all('settings').getList().then(function(data) {
        $scope.settings = data[0];
        return $scope.settings.rootObjectName = 'gym_mobile_app_detail';
      });
      saveSettings = function() {
        flash.success = null;
        return $scope.settings.save().then(function(data) {
          $scope.settings = data;
          $scope.settings.rootObjectName = 'gym_mobile_app_detail';
          return flash.success = 'Updated successfully';
        });
      };
      $scope.saveSettings = _.debounce(function() {
        return saveSettings();
      }, 1500);
      $scope.onCancelledMembersToggle = function(event) {
        if (!$scope.isInvitationAvailable()) {
          event.preventDefault();
          return MessageService.message({
            title: 'Setting cannot be changed at this time',
            message: ["Your white label mobile app is currently being provisioned. During this time, some mobile app settings will be frozen to ensure your app can be reviewed and released to the app stores as quickly as possible.", "You will be able to change this setting as soon as your mobile app has been released. Thank you for your patience."],
            confirmButtonText: 'Ok'
          });
        }
      };
      $scope.isInvitationAvailable = function() {
        return MobileAppService.isInvitationAvailable($scope.mobileAppSettings);
      };
      $scope.toggleAccess = function() {
        var action, message;
        action = $scope.settings.mobile_app_access_enabled ? 'block' : 'allow';
        message = `Are you sure? This will ${action} your users to sign in to your Clubworx mobile app.`;
        if ($window.confirm(message)) {
          $scope.settings.mobile_app_access_enabled = !$scope.settings.mobile_app_access_enabled;
          return saveSettings();
        }
      };
      return $scope.newEzidebitPaymentMethodsAllowedOptions = [
        {
          label: 'Credit cards and bank accounts (no restriction)',
          value: 'allow_both_ezidebit_payment_methods_to_be_added'
        },
        {
          label: 'Credit cards only',
          value: 'allow_only_ezidebit_credit_cards_to_be_added'
        },
        {
          label: 'Bank accounts only',
          value: 'allow_only_ezidebit_bank_accounts_to_be_added'
        }
      ];
    }]
  };
});
